/**
 * @module Utilities/Cache
 * @desc Cache helper funtions
 */

import type { ValidLocaleCacheData, ValidLocaleCacheOptions } from './cache';
import { hasValidCache } from './has-valid-cache';

/**
 * Check if cache with options is valid
 */
export function hasValidLocaleCache(data: ValidLocaleCacheData, options: ValidLocaleCacheOptions) {
  const { baseSite, currency, locale, max = 10 } = options;

  return (
    data.baseSite === baseSite &&
    data.currency === currency &&
    data.locale === locale &&
    hasValidCache(data.updatedAt, max)
  );
}
